<template>
  <StringTemplateRenderer
    class="naturalLanguageInput"
    :content="label"
    :disabled="disabled"
  >
    <template slot="value">
      <input
        class="naturalLanguageInput__input"
        :class="{
          'naturalLanguageInput__input--center': center,
          'naturalLanguageInput__input--error': validationError,
          'naturalLanguageInput__input--disabled': disabled,
        }"
        :disabled="disabled"
        v-model="inputValue"
        v-bind="inputAttributes"
        :style="textInputStyle"
      />
      <slot></slot>
    </template>
  </StringTemplateRenderer>
</template>

<script>
import calculateTextWidth from "text-width";
import BaseComponent from "../../BaseComponent";
import InputBase from "./mixins/InputBase";
import StringTemplateRenderer from "../StringTemplateRenderer.vue";

export default {
  mixins: [BaseComponent, InputBase],
  name: "NaturalLanguageInput",
  components: {
    StringTemplateRenderer,
  },
  props: {
    // @vuese
    // The i18n label, which text will be rendered inline to this component.
    label: {
      type: String,
      required: true,
    },
    // pass any native html attributes to the underlying input element using this prop.
    // e.g. :inputAttributes="{ type: 'number', disabled: true }"
    inputAttributes: {
      type: Object,
      default: () => ({
        type: "text",
      }),
    },
    // Toggle the validation state styling.
    validationError: {
      type: Boolean,
      default: false,
    },
    // Centers the text in the input field
    center: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    textInputStyle() {
      const textWidth = calculateTextWidth(this.value, {
        size: 14,
        family: "Open Sans",
      });
      return {
        width: `calc(${textWidth}px + 1ch)`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style_variables/style_variables.scss";

.naturalLanguageInput {
  padding-right: 8px;
}

.naturalLanguageInput__input {
  @extend %body1_style;
  display: inline-flex;
  position: relative;
  background-color: $white;
  border: 1px solid $grey_french;
  border-radius: 4px;
  height: 36px;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-right: 8px;
  padding: 0px 1ch;
  box-sizing: content-box;
  text-align: left;
  min-width: 40px;
  &:hover,
  &:focus {
    border: 1px solid $grey_bombay;
  }

  &.naturalLanguageInput__input--center {
    text-align: center;
  }

  &.naturalLanguageInput__input--error {
    border-color: $red;
    transition: all 0.3s;
  }

  &.naturalLanguageInput__input--disabled {
    background-color: $grey_bg;
    color: $grey_mischka;
    border: 1px solid $grey_mischka;
  }
}

// Remove stepper from number type input
// Chrome, Safari, Edge, Opera
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

// Firefox
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
